/*
 * @Author: your name
 * @Date: 2022-03-02 09:37:30
 * @LastEditTime: 2022-08-14 12:17:54
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\BsyMsgBubble\dlg.jsx
 */
import React, { Component } from "react";
import BsyIconBtn from "../BsyIconBtn";
import BsyTableContainer from '../BsyTableContainer';
import './index.css'


export default class Dlg extends Component {

    constructor(props) {
        super(props);
        this.state = {

        }
        this.element = React.createRef();
    }

    componentDidMount() {
        // console.log('BsyMsgBubble', this.element.current.offsetHeight)
        let that = this;
        setTimeout(() => {
            that.props.renderStyle();
        }, 100)

    }

    closeAlter = () => {
        this.props.onRemoveRoot()
    }

    _renderContent() {
        if (this.props.contentHTML) {
            return this.props.contentHTML(this);
        } else {
            return <BsyTableContainer attr={this.props.contentWidget} />
        }

    }

    onCancelClick = () => {
        if (this.props.onClose) {
            if (this.props.onClose() === false) {
                return;
            }
        }
        this.closeAlter();
    }

    onCustomClick = () => {
        if (this.props.onCustom) {
            if (this.props.onCustom() === false) {
                return;
            }
        }
        this.closeAlter();
    }


    onOkClick = () => {
        if (this.props.onOk) {
            if (this.props.onOk() === false) {
                return;
            }
        }
        this.closeAlter();
    }



    render() {
        const { height, width, maxHeight, minHeight } = this.props
        return (
            <div className="content" style={{
                width: width ? width : '',
                height: height ? height : '',
                maxHeight: maxHeight ? maxHeight : '',
                minHeight: minHeight ? minHeight : '',
            }}
                ref={this.element}
            >
                <div className="content-body">

                    {this._renderContent()}

                </div>
            </div>
        )
    }
}

// Dlg.defaultProps = {
//     okText: React.language("ok"), 
//     onOk:null,
//     cancelText: React.language("cancel"),
//     onCancel:null,
// }